import React, { useState } from 'react'
import { Button } from '@mui/material';
import { configApiRef, identityApiRef, useApi } from '@backstage/core-plugin-api';

/** @public */
export const ManagedIdentityTokenPrintComponent = () => {
  const config = useApi(configApiRef);
  const identityApi = useApi(identityApiRef);
  const backendUrl = config.getString('backend.baseUrl');

  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');

  const handleClick = async () => {
    const url = `${backendUrl}/api/bidone/configuration/managed-identity-print`;
    const { token: accessToken } = await identityApi.getCredentials();
    try {
      setMsg('Requesting...')
      setLoading(true);
      await fetch(
        url,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
          },
        },
      );
      setMsg('A copy of the token has been printed out on the server console, check on Kudu or equivalent tools.')
    }
    catch (error) {
      setMsg(JSON.stringify(error));
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <Button variant='contained' color='primary' disabled={loading} onClick={handleClick}>Print Managed Identity Token</Button>
      <p>{msg}</p>
    </>
  );
};